import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddWorkExperienceLevels, WorkExperienceLevels } from '../models/workexperiencelevels/workexperiencelevels';


@Injectable({
  providedIn: 'root'
})
export class WorkExperienceLevelsService {

  constructor(
    private _http: HttpClient
  ) { }

    public getWorkExperienceLevels(WorkExperienceLevelsId?: number): Observable<WorkExperienceLevels[]>{
        return this._http.get<WorkExperienceLevels[]>(`${environment.api.url}/EmploymentExperienceLevels?EmploymentExperienceLevelsId=${WorkExperienceLevelsId??''}`);
    }
  
    public deleteWorkExperienceLevels(WorkExperienceLevelsId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/EmploymentExperienceLevels/${WorkExperienceLevelsId}`);
    }
  
    public addWorkExperienceLevels(model: AddWorkExperienceLevels): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/EmploymentExperienceLevels`, model);
    }
}
